module.exports = __webpack_public_path__ + "img/no_data.2dee5ac9.png";